// @ts-nocheck
import { format } from 'date-fns';
import { toastr } from 'react-redux-toastr';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import {
  categoriaFailure,
  categoriaRequest,
  categoriaSuccess,
  personalFailure,
  personalRequest,
  personalSuccess,
} from './actions';
import { PersonalTypes } from './types';

function* personal({ payload }: ReturnType<typeof personalRequest>) {
  const { identification_key, ownership_type, company } = payload.config;

  const identificationKeyChanged = identification_key.replace(/[^\d]+/g, '');

  try {
    const response = yield call(
      api.get,
      `/v1/titulares?key=${identificationKeyChanged}&ownershypType=${ownership_type}`,
      {
        headers: {
          'Content-Type': 'application/json',
          company: company,
        },
      },
    );

    let assinante: any[] = [];
    let dados_cadastrais_funcionario: any[] = [];
    let proposta: any = null;
    let propostas: any = null;
    let dados_cadastrais_candidato: any = null;
    let instaladores: any = null;
    let pontos_de_venda: any = null;
    let terceiros: any = null;
    let tipo: any = null;
    let data_status: any = null;

    for (let i = 0; i < response.data.personal_data.length; i++) {
      const element = response.data.personal_data[i];

      tipo = element?.tipo;
      data_status = element.data_status;

      assinante.push({
        dadosPessoais: {
          Codigo_Cliente_Siebel: element.codigo_siebel,
          CPF_CNPJ_CLENTE: element.cpf,
          Nome_cliente: element.nome,
          Sobrenome_cliente: element.sobrenome,
          numero_proposta: element.numero_proposta,
          Principal_Email_Cliente: element.emails?.filter(
            email => email.tipo === 'Principal',
          ),
          Telefone_Cliente: element.telefones?.map(telefone => {
            if (
              telefone.ddd !== null &&
              telefone.ddd !== ' ' &&
              telefone.ddd !== '' &&
              telefone.ddd !== undefined &&
              telefone.ddd !== 'null' &&
              telefone.numero !== null &&
              telefone.numero !== ' ' &&
              telefone.numero !== '' &&
              telefone.numero !== undefined &&
              telefone.numero !== 'null' &&
              telefone.tipo !== null &&
              telefone.tipo !== ' ' &&
              telefone.tipo !== '' &&
              telefone.tipo !== undefined &&
              telefone.tipo !== 'null'
            ) {
              let formatedNumber = `${telefone.numero.substring(
                0,
                telefone.numero.length - 4,
              )}-${telefone.numero.substring(
                telefone.numero.length - 4,
                telefone.numero.length,
              )}`;

              return {
                [telefone.tipo]: `${telefone.ddd} ${formatedNumber}`,
              };
            }
          }),
          Data_Nascimento_Cliente: !!element.data_nascimento
            ? format(new Date(element.data_nascimento), 'dd/MM/yyyy')
            : '',
          Enderecos: element.enderecos?.map(endereco => {
            return {
              bairro_endereco: endereco.bairro_endereco,
              cependereco: endereco.cependereco,
              cidade_endereco: endereco.cidade_endereco,
              codigo_ibgelogradouro: endereco.codigo_ibgelogradouro,
              complemento_endereco: endereco.complemento_endereco,
              dddtelefone: endereco.dddtelefone,
              endereco: endereco.endereco,
              finalidade_endereco: endereco.finalidade_endereco,
              numero_endereco: endereco.numero_endereco,
              numero_telefone_com_ddd: `${
                endereco.dddtelefone
              } ${endereco.numero_telefone?.substring(
                endereco.numero_telefone?.length - 4,
                endereco.numero_telefone?.length,
              )}-${endereco.numero_telefone?.substring(
                0,
                endereco.numero_telefone?.length - 4,
              )}`,
              ponto_referencia_end: endereco.ponto_referencia_end,
              tipo_endereco: endereco.tipo_endereco,
              ufendereco: endereco.ufendereco,
            };
          }),
          contatos: element?.contatos?.map(el => {
            return {
              email_Contato_Cliente: el?.email_Contato_Cliente,
            };
          }),
        },
        Produtos: {
          parques_clientes: element.parques_cliente?.map(produto => {
            return {
              Nome_Produto_Cliente: produto.Nome_Produto_Cliente,
              Categoria_Produto_Cliente: produto.Categoria_Produto_Cliente,
            };
          }),
        },
      });

      dados_cadastrais_funcionario.push({
        tem_dependentes: element.tem_dependentes,
        tem_beneficiarios: element.tem_beneficiarios,
        Dados_Cadastrais: {
          Matricula_Empregado:
            element.dados_cadastrais_funcionario?.Matricula_Empregado,
          Nome_Empregado: element.dados_cadastrais_funcionario?.Nome_Empregado,
          Genero_Empregado:
            element.dados_cadastrais_funcionario?.Genero_Empregado,
          Data_Nascimento_Empregado:
            element.dados_cadastrais_funcionario?.Data_Nascimento_Empregado,
          CPF_Empregado: element.dados_cadastrais_funcionario?.CPF_Empregado,
          Endereco_Residencial_Empregado:
            element.dados_cadastrais_funcionario
              ?.Endereco_Residencial_Empregado,
          Numero_Logradouro_Empregado:
            element.dados_cadastrais_funcionario?.Numero_Logradouro_Empregado,
          Complemento_Endereco_Empregado:
            element.dados_cadastrais_funcionario
              ?.Complemento_Endereco_Empregado,
          Cidade_Endereco_Empregado:
            element.dados_cadastrais_funcionario?.Cidade_Endereco_Empregado,
          CEP_Endereco_Empregado:
            element.dados_cadastrais_funcionario?.CEP_Endereco_Empregado,
          Tipo_Endereco_Empregado:
            element.dados_cadastrais_funcionario?.Tipo_Endereco_Empregado,
          Estado_Endereco_Empregado:
            element.dados_cadastrais_funcionario?.Estado_Endereco_Empregado,
          Email_Pessoal_Empregado:
            element.dados_cadastrais_funcionario?.Email_Pessoal_Empregado,
          Celular_Empregado: `${
            element.dados_cadastrais_funcionario?.DDI_Celular_Empregado
          } ${
            element.dados_cadastrais_funcionario?.DDD_Celular_Empregado
          } ${element.dados_cadastrais_funcionario?.Numero_Celular_Empregado?.substring(
            0,
            element.dados_cadastrais_funcionario?.Numero_Celular_Empregado
              ?.length - 4,
          )}-${element.dados_cadastrais_funcionario?.Numero_Celular_Empregado?.substring(
            element.dados_cadastrais_funcionario?.Numero_Celular_Empregado
              ?.length - 4,
            element.dados_cadastrais_funcionario?.Numero_Celular_Empregado
              ?.length,
          )}`,
          Telefone_Residencial_Empregado: `${
            element.dados_cadastrais_funcionario?.Codigo_DDI_Telefone_Empregado
          } ${
            element.dados_cadastrais_funcionario?.Codigo_DDD_Telefone_Empregado
          } ${element.dados_cadastrais_funcionario?.Telefone_Residencial_Empregado?.substring(
            0,
            element.dados_cadastrais_funcionario?.Telefone_Residencial_Empregado
              ?.length - 4,
          )}-${element.dados_cadastrais_funcionario?.Telefone_Residencial_Empregado?.substring(
            element.dados_cadastrais_funcionario?.Telefone_Residencial_Empregado
              ?.length - 4,
            element.dados_cadastrais_funcionario?.Telefone_Residencial_Empregado
              ?.length,
          )}`,
          RG_Empregado: element.dados_cadastrais_funcionario?.RG_Empregado,
          UF_Emissor_RG_Empregado:
            element.dados_cadastrais_funcionario?.UF_Emissor_RG_Empregado,
          Orgao_Emissor_RG_Empregado:
            element.dados_cadastrais_funcionario?.Orgao_Emissor_RG_Empregado,
          Dt_Expedicao_Emissor_RG_Empregado:
            element.dados_cadastrais_funcionario
              ?.Dt_Expedicao_Emissor_RG_Empregado,
          Letra_CTPS_Empregado:
            element.dados_cadastrais_funcionario?.Letra_CTPS_Empregado,
          Numero_CTPS_Empregado:
            element.dados_cadastrais_funcionario?.Numero_CTPS_Empregado,
          Serie_CTPS_Empregado:
            element.dados_cadastrais_funcionario?.Serie_CTPS_Empregado,
          Estado_CTPS_Empregado:
            element.dados_cadastrais_funcionario?.Estado_CTPS_Empregado,
          Data_Expedicao_CTPS_Empregado:
            element.dados_cadastrais_funcionario?.Data_Expedicao_CTPS_Empregado,
          Dt_Validade_CTPS_Empregado:
            element.dados_cadastrais_funcionario?.Dt_Validade_CTPS_Empregado,
          Numero_PIS_Empregado:
            element.dados_cadastrais_funcionario?.Numero_PIS_Empregado,
          DT_Expedicao_PIS_Empregado:
            element.dados_cadastrais_funcionario?.DT_Expedicao_PIS_Empregado,
          Numero_Inscricao_INSS_Empregado:
            element.dados_cadastrais_funcionario
              ?.Numero_Inscricao_INSS_Empregado,
          Numero_Beneficio_INSS_Empregado:
            element.dados_cadastrais_funcionario
              ?.Numero_Beneficio_INSS_Empregado,
          Classe_Contribuicao_INSS_Empregado:
            element.dados_cadastrais_funcionario
              ?.Classe_Contribuicao_INSS_Empregado,
          Numero_RIC_Empregado:
            element.dados_cadastrais_funcionario?.Numero_RIC_Empregado,
          Orgao_Emissor_RIC_Empregado:
            element.dados_cadastrais_funcionario?.Orgao_Emissor_RIC_Empregado,
          Data_Expedicao_RIC_Empregado:
            element.dados_cadastrais_funcionario?.Data_Expedicao_RIC_Empregado,
          Carteira_Habilitacao_Empregado:
            element.dados_cadastrais_funcionario
              ?.Carteira_Habilitacao_Empregado,
          Categoria_CNH_Empregado:
            element.dados_cadastrais_funcionario?.Categoria_CNH_Empregado,
          Orgao_Emissor_CNH_Empregado:
            element.dados_cadastrais_funcionario?.Orgao_Emissor_CNH_Empregado,
          Data_Expedicao_CNH_Empregado:
            element.dados_cadastrais_funcionario?.Data_Expedicao_CNH_Empregado,
          Data_Validade_CNH_Empregado:
            element.dados_cadastrais_funcionario?.Data_Validade_CNH_Empregado,
          UF_Expedicao_CNH_Empregado:
            element.dados_cadastrais_funcionario?.UF_Expedicao_CNH_Empregado,
          Dt_Primeira_Hab_CNH_Empregado:
            element.dados_cadastrais_funcionario?.Dt_Primeira_Hab_CNH_Empregado,
          Carteira_Habilitacao_2019:
            element.dados_cadastrais_funcionario?.Carteira_Habilitacao_2019,
          Orgao_Carteira_Habilitacao_2019:
            element.dados_cadastrais_funcionario
              ?.Orgao_Carteira_Habilitacao_2019,
          Data_expedicao_Carteira_Hab_2019:
            element.dados_cadastrais_funcionario
              ?.Data_expedicao_Carteira_Hab_2019,
          Numero_Titulo_Eleitor_Empregado:
            element.dados_cadastrais_funcionario
              ?.Numero_Titulo_Eleitor_Empregado,
          Secao_TE_Empregado:
            element.dados_cadastrais_funcionario?.Secao_TE_Empregado,
          Zona_TE_Empregado:
            element.dados_cadastrais_funcionario?.Zona_TE_Empregado,
          Certificado_Reservista_Empregado:
            element.dados_cadastrais_funcionario
              ?.Certificado_Reservista_Empregado,
          Complemento_CR_Empregado:
            element.dados_cadastrais_funcionario?.Complemento_CR_Empregado,
          Codgio_Orgao_Classe_Empregado:
            element.dados_cadastrais_funcionario?.Codgio_Orgao_Classe_Empregado,
          Regiao_Orgao_Classe_Empregado:
            element.dados_cadastrais_funcionario?.Regiao_Orgao_Classe_Empregado,
          Numero_Regiao_Orgao_Classe_Empregado:
            element.dados_cadastrais_funcionario
              ?.Numero_Regiao_Orgao_Classe_Empregado,
          UF_Orgao_Classe_Empregado:
            element.dados_cadastrais_funcionario?.UF_Orgao_Classe_Empregado,
          Dt_Expedicao_Orgao_Classe_Empregado:
            element.dados_cadastrais_funcionario
              ?.Dt_Expedicao_Orgao_Classe_Empregado,
          Dt_Validade_Orgao_Classe_Empregado:
            element.dados_cadastrais_funcionario
              ?.Dt_Validade_Orgao_Classe_Empregado,
          Data_Admissao_Empregado:
            element.dados_cadastrais_funcionario?.Data_Admissao_Empregado,
          Data_Termino_Contrato_Empregado:
            element.dados_cadastrais_funcionario
              ?.Data_Termino_Contrato_Empregado,
          Nome_Mae_Empregado:
            element.dados_cadastrais_funcionario?.Nome_Mae_Empregado,
          Nome_Pai_Empregado:
            element.dados_cadastrais_funcionario?.Nome_Pai_Empregado,
          Natureza_Estagio:
            element.dados_cadastrais_funcionario?.Natureza_Estagio,
          CPF_Coordenador_Estagio:
            element.dados_cadastrais_funcionario?.CPF_Coordenador_Estagio,
          Nome_Coordenador_Estagio:
            element.dados_cadastrais_funcionario?.Nome_Coordenador_Estagio,
          Apolice_Seguro_Estagio:
            element.dados_cadastrais_funcionario?.Apolice_Seguro_Estagio,
          Data_Fim_Estagio:
            element.dados_cadastrais_funcionario?.Data_Fim_Estagio,
        },
        Dados_Financeiros: {
          Codigo_Banco_Empregado:
            element.dados_cadastrais_funcionario?.Codigo_Banco_Empregado,
          Codigo_Agencia_Bancaria_Empregado:
            element.dados_cadastrais_funcionario
              ?.Codigo_Agencia_Bancaria_Empregado,
          Conta_Corrente_Empregado:
            element.dados_cadastrais_funcionario?.Conta_Corrente_Empregado,
          DV_Conta_Corrente_Empregado:
            element.dados_cadastrais_funcionario?.DV_Conta_Corrente_Empregado,
        },
        Dependentes: element.dados_cadastrais_funcionario?.Dependentes?.map(
          el => {
            return {
              Nome_Dependente: el.Nome_Dependente,
              Data_Nascimento_Dependente: el.Data_Nascimento_Dependente,
              Numero_CPF_Dependente: el.Numero_CPF_Dependente,
              Numero_RG_Dependente: el.Numero_RG_Dependente,
              Estado_Emissor_RG_Dependente: el.Estado_Emissor_RG_Dependente,
              Orgao_Emissor_RG_Dpendente: el.Orgao_Emissor_RG_Dpendente,
              Data_Expedicao_RG_Dependente: el.Data_Expedicao_RG_Dependente,
              Ds_Parentesco: el.Ds_Parentesco,
              Cartorio_Registor_Dependente: el.Cartorio_Registor_Dependente,
              NRO_REGISTRO: el.NRO_REGISTRO,
              Numero_Livro_Registro_Dep: el.Numero_Livro_Registro_Dep,
              Numero_Folha_Registro_Dep: el.Numero_Folha_Registro_Dep,
              Genero_Dependente: el.Genero_Dependente,
            };
          },
        ),
        Beneficiarios: element.dados_cadastrais_funcionario?.Beneficiarios?.map(
          el => {
            return {
              Nome_Beneficiario: el.Nome_Beneficiario,
              Numero_CPF_Beneficiario: el.Numero_CPF_Beneficiario,
              Numero_RG_Beneficiario: el.Numero_RG_Beneficiario,
              Orgao_Emissor_RG_Beneficiario: el.Orgao_Emissor_RG_Beneficiario,
              Estado_Emissor_RG_Beneficiario: el.Estado_Emissor_RG_Beneficiario,
              Endereco_Beneficiario: el.Endereco_Beneficiario,
              Numero_Endereco_Beneficiario: el.Numero_Endereco_Beneficiario,
              Complemento_End_Beneficiario: el.Complemento_End_Beneficiario,
              Bairro_Beneficiario: el.Bairro_Beneficiario,
              Cidade_Beneficiario: el.Cidade_Beneficiario,
              Estado_Beneficiario: el.Estado_Beneficiario,
              CEP_Beneficiario: el.CEP_Beneficiario,
            };
          },
        ),
      });

      proposta = element.proposta?.map(dados => {
        return {
          Numero_Proposta: dados?.Numero_Proposta,
          Nome_Prosponente:
            element.proponentes && element.proponentes[0].Nome_Prosponente,
          Sobrenome_Prosponente:
            element.proponentes && element.proponentes[0].Sobrenome_Prosponente,
          endereco: element.enderecos && element.enderecos[0].endereco,
          numero_endereco:
            element.enderecos && element.enderecos[0].numero_endereco,
          complemento_endereco:
            element.enderecos && element.enderecos[0].complemento_endereco,
          cependereco: element.enderecos && element.enderecos[0].cependereco,
          cidade_endereco:
            element.enderecos && element.enderecos[0].cidade_endereco,
          ufendereco: element.enderecos && element.enderecos[0].ufendereco,
          Email_Prosponente:
            element.proponentes && element.proponentes[0].Email_Prosponente,
          Telefone_Celular_Proponente:
            dados.Telefone_Celular_Proponente &&
            `${
              dados.DDD_Telefone_Celular_Proponente
            } ${dados.Telefone_Celular_Proponente.substring(
              0,
              dados.Telefone_Celular_Proponente.length - 4,
            )}-${dados.Telefone_Celular_Proponente.substring(
              dados.Telefone_Celular_Proponente.length - 4,
              dados.Telefone_Celular_Proponente.length,
            )}`,
          Telefone_Comercial_Prosponente:
            dados.Telefone_Comercial_Prosponente &&
            `${
              dados.DDD_Telefone_Comercial_Proponente
            } ${dados.Telefone_Comercial_Prosponente.substring(
              0,
              dados.Telefone_Comercial_Prosponente.length - 4,
            )}-${dados.Telefone_Comercial_Prosponente.substring(
              dados.Telefone_Comercial_Prosponente.length - 4,
              dados.Telefone_Comercial_Prosponente.length,
            )}`,
          Telefone_Residencial_Prosponente:
            dados.Telefone_Residencial_Proponente &&
            `${
              dados.DDD_Telefone_Residencial_Proponente
            } ${dados.Telefone_Residencial_Proponente.substring(
              0,
              dados.Telefone_Residencial_Proponente.length - 4,
            )}-${dados.Telefone_Residencial_Proponente.substring(
              dados.Telefone_Residencial_Proponente.length - 4,
              dados.Telefone_Residencial_Proponente.length,
            )}`,
          CPF_Prosponente: element?.proponentes[0]?.CPF_Prosponente,
          RG_Prosponente: element?.proponentes[0]?.RG_Prosponente,
          Passaporte_Prosponente:
            element?.proponentes[0]?.Passaporte_Prosponente,
          bairro_endereco: element?.enderecos[0]?.bairro_endereco,
          apartamento: element?.enderecos[0]?.apartamento,
        };
      });

      propostas = element?.propostas?.map(dados => {
        return {
          Numero_Proposta_Prosponente: dados?.Numero_Proposta_Prosponente,
          Nome_Proponente: element?.dados_cadastrais[0]?.Nome_Proponente,
          Nome_Meio_Poroponente:
            element?.dados_cadastrais[0]?.Nome_Meio_Poroponente,
          Sobrenome_Proponente:
            element?.dados_cadastrais[0]?.Sobrenome_Proponente,
          Endereço_Instalacao_Proponente:
            element?.dados_cadastrais[0]?.Endereço_Instalacao_Proponente,
          Numero_End_Instalacao_Proponente:
            element?.dados_cadastrais[0]?.Numero_End_Instalacao_Proponente,
          Complemento_Instalacao_Proponente:
            element?.dados_cadastrais[0]?.Complemento_Instalacao_Proponente,
          Bairro_Proponente: element?.dados_cadastrais[0]?.Bairro_Proponente,
          CEP_Instalacao_Proponente:
            element?.dados_cadastrais[0]?.CEP_Instalacao_Proponente,
          Cidade_Instalacao_Proponente:
            element?.dados_cadastrais[0]?.Cidade_Instalacao_Proponente,
          Estado_Instalacao_Proponente:
            element?.dados_cadastrais[0]?.Estado_Instalacao_Proponente,
          Telefone_Proponente:
            element?.dados_cadastrais[0]?.Telefone_Proponente,
          Tipo_Residencia_Instalacao_Proponente:
            element?.dados_cadastrais[0]?.Tipo_Residencia_Instalacao_Proponente,
          Telefone_Residencial_Proposta_Prosponente:
            dados?.Telefone_Residencial_Proposta_Prosponente,
          Email_Pessoal_Proponente:
            element?.dados_cadastrais[0]?.Email_Pessoal_Proponente,
          Email_Comercial_Proponente:
            element?.dados_cadastrais[0]?.Email_Comercial_Proponente,
          Celular_Proponente: element?.dados_cadastrais[0]?.Celular_Proponente,
          Celular_pessoal_Proponente:
            element?.dados_cadastrais[0]?.Celular_pessoal_Proponente,
          Telefone_Comercial_Proponente:
            element?.dados_cadastrais[0]?.Telefone_Comercial_Proponente,
          CPF_Proponente: element?.dados_cadastrais[0]?.CPF_Proponente,
          RG_Proponente: element?.dados_cadastrais[0]?.RG_Proponente,
        };
      });

      dados_cadastrais_candidato = element?.dados_cadastrais_candidato?.map(
        data => {
          return {
            CPF_Candidato: data?.CPF_Candidato,
            Nome_Candidato: data?.Nome_Candidato,
            Sobrenome_Candidato: data?.Sobrenome_Candidato,
            Data_Nascimento_Candidato: data?.Data_Nascimento_Candidato,
            Numero_RG_Candidato: data?.Numero_RG_Candidato,
            Codigo_Postal_Candidato: data?.Codigo_Postal_Candidato,
            Endereco_residencial_Candidato:
              data?.Endereco_residencial_Candidato,
            Endereco_Linha_2_residencial_Candidato:
              data?.Endereco_Linha_2_residencial_Candidato,
            Complemento_Endereco_cancidato:
              data?.Complemento_Endereco_cancidato,
            Cidade_Candidato: data?.Cidade_Candidato,
            Regiao_Logradouro_Candidato: data?.Regiao_Logradouro_Candidato,
            Estado_Candidato: data?.Estado_Candidato,
            Pais_Logradouro_Candidato: data?.Pais_Logradouro_Candidato,
            Email_Candidato: data?.Email_Candidato,
            Tipo_Telefone_Contato_Principal:
              data?.Tipo_Telefone_Contato_Principal,
            Celular_Candidato:
              !!data?.Numero_Celular_Candidato &&
              `${data?.DDI_Celular_Candidato} ${
                data?.DDD_Celular_candidato
              } ${data?.Numero_Celular_Candidato?.substring(
                0,
                data?.Numero_Celular_Candidato?.length - 4,
              )}-${data?.Numero_Celular_Candidato?.substring(
                data?.Numero_Celular_Candidato?.length - 4,
                data?.Numero_Celular_Candidato?.length,
              )}`,
            Telefone_Comercial_Candidato:
              !!data?.Numero_Telefone_Comercial_Candidato &&
              `${data?.DDI_Telefone_Comercial_Candidato} ${
                data?.DDD_Telefone_Comercial_Candidato
              } ${data?.Numero_Telefone_Comercial_Candidato?.substring(
                0,
                data?.Numero_Telefone_Comercial_Candidato?.length - 4,
              )}-${data?.Numero_Telefone_Comercial_Candidato?.substring(
                data?.Numero_Telefone_Comercial_Candidato?.length - 4,
                data?.Numero_Telefone_Comercial_Candidato?.length,
              )}`,
            Numero_PIS_Candidato: data?.Numero_PIS_Candidato,
            Data_Emissao_PIS_Candidato: data?.Data_Emissao_PIS_Candidato,
            Numero_NIT: data?.Numero_NIT,
            Data_Cadastro_NIT: data?.Data_Cadastro_NIT,
          };
        },
      );

      instaladores = element?.instaladores?.map(instalador => {
        return {
          tipo: element?.tipo,
          Numero_instalador: instalador.Numero_instalador,
          Nome_Instalador: instalador.Nome_Instalador,
          Email_Instalador: instalador.Email_Instalador,
          RG_Instalador: instalador.RG_Instalador,
          CPF_Instalador: instalador.CPF_Instalador,
          Celular_com_DDD_Instalador:
            !!instalador?.Celular_Instalador &&
            `${
              instalador.DDD_Celular_Instalador
            } ${instalador.Celular_Instalador?.substring(
              0,
              instalador.Celular_Instalador?.length - 4,
            )}-${instalador.Celular_Instalador?.substring(
              instalador.Celular_Instalador?.length - 4,
              instalador.Celular_Instalador?.length,
            )}`,
          Telefone_1_com_DDD_Instalador:
            !!instalador?.Telefone_1_Instalador &&
            `${
              instalador.DDD_Telefone_1_Instalador
            } ${instalador.Telefone_1_Instalador?.substring(
              0,
              instalador.Telefone_1_Instalador?.length - 4,
            )}-${instalador.Telefone_1_Instalador?.substring(
              instalador.Telefone_1_Instalador?.length - 4,
              instalador.Telefone_1_Instalador?.length,
            )}`,
          Telefone_2_com_DDD_Instalador:
            !!instalador?.Telefone_2_Instalador &&
            `${
              instalador.DDD_Telefone_2_Instalador
            } ${instalador.Telefone_2_Instalador?.substring(
              0,
              instalador.Telefone_2_Instalador?.length - 4,
            )}-${instalador.Telefone_2_Instalador?.substring(
              instalador.Telefone_2_Instalador?.length - 4,
              instalador.Telefone_2_Instalador?.length,
            )}`,
          Telefone_3_com_DDD_Instalador:
            !!instalador?.Telefone_3_Instalador &&
            `${
              instalador.DDD_Telefone_3_Instalador
            } ${instalador.Telefone_3_Instalador?.substring(
              0,
              instalador.Telefone_3_Instalador?.length - 4,
            )}-${instalador.Telefone_3_Instalador?.substring(
              instalador.Telefone_3_Instalador?.length - 4,
              instalador.Telefone_3_Instalador?.length,
            )}`,
          Telefone_4_com_DDD_Instalador:
            !!instalador?.Telefone_4_Instalador &&
            `${
              instalador.DDD_Telefone_4_Instalador
            } ${instalador.Telefone_4_Instalador?.substring(
              0,
              instalador.Telefone_4_Instalador?.length - 4,
            )}-${instalador.Telefone_4_Instalador?.substring(
              instalador.Telefone_4_Instalador?.length - 4,
              instalador.Telefone_4_Instalador?.length,
            )}`,
          Endereco_Instalador: instalador.Endereco_Instalador,
          Complemento_Endereco_Instalador:
            instalador.Complemento_Endereco_Instalador,
          Cidade_Logradouro_Instalador: instalador.Cidade_Logradouro_Instalador,
          CEP_Logradouro_Instalador: instalador.CEP_Logradouro_Instalador,
          Numero_Endereco_Instalador: instalador.Numero_Endereco_Instalador,
          Telefone_Contato_referencia_Instalador: `${
            instalador.Telefone_Contato_Instalador
          } ${instalador.Telefone_contato_referencia_Instalador?.substring(
            0,
            instalador.Telefone_contato_referencia_Instalador?.length - 4,
          )}-${instalador.Telefone_contato_referencia_Instalador?.substring(
            instalador.Telefone_contato_referencia_Instalador?.length - 4,
            instalador.Telefone_contato_referencia_Instalador?.length,
          )}`,
        };
      });

      pontos_de_venda = element?.pontos_de_venda?.map((dados, index) => {
        return {
          conta: `Contrato - ${index + 1} - Vendedor`,
          CPF_Parceiro_Vendedor: dados.CPF_Parceiro_Vendedor,
          RG_Parceiro_Vendedor: dados.RG_Parceiro_Vendedor,
          Nome_Empresa_Vendedor: dados.Nome_Empresa_Vendedor,
          Nome_Parceiro_Vendedor: dados.Nome_Parceiro_Vendedor,
          Sobrenome_Parceiro_Vendedor: dados.Sobrenome_Parceiro_Vendedor,
          Email_Parceiro_Vendedor: dados.Email_Parceiro_Vendedor,
          Telefone_Res_Parceiro_Vendedor:
            dados.Telefone_Res_Parceiro_Vendedor &&
            `${dados.Telefone_Res_Parceiro_Vendedor?.substring(
              0,
              2,
            )} ${dados.Telefone_Res_Parceiro_Vendedor?.substring(
              2,
              dados.Telefone_Res_Parceiro_Vendedor?.length - 4,
            )}-${dados.Telefone_Res_Parceiro_Vendedor?.substring(
              dados.Telefone_Res_Parceiro_Vendedor?.length - 4,
              dados.Telefone_Res_Parceiro_Vendedor?.length,
            )}`,
          Celular_Parceiro_Vendedor:
            dados.Celular_Parceiro_Vendedor &&
            `${dados.Celular_Parceiro_Vendedor?.substring(
              0,
              2,
            )} ${dados.Celular_Parceiro_Vendedor?.substring(
              2,
              dados.Celular_Parceiro_Vendedor?.length - 4,
            )}-${dados.Celular_Parceiro_Vendedor?.substring(
              dados.Celular_Parceiro_Vendedor?.length - 4,
              dados.Celular_Parceiro_Vendedor?.length,
            )}`,
          Outro_Telefone_Parceiro_Vendedor:
            dados.Outro_Telefone_Parceiro_Vendedor &&
            `${dados.Outro_Telefone_Parceiro_Vendedor?.substring(
              0,
              2,
            )} ${dados.Outro_Telefone_Parceiro_Vendedor?.substring(
              2,
              dados.Outro_Telefone_Parceiro_Vendedor?.length - 4,
            )}-${dados.Outro_Telefone_Parceiro_Vendedor?.substring(
              dados.Outro_Telefone_Parceiro_Vendedor?.length - 4,
              dados.Outro_Telefone_Parceiro_Vendedor?.length,
            )}`,
          Foto_Parceiro_Vendedor: dados.Foto_Parceiro_Vendedor,
          Genero_Vendedor: dados.Genero_Vendedor,
          Telefone_Parceiro_Vendedor:
            dados.Telefone_Parceiro_Vendedor &&
            `${dados.Telefone_Parceiro_Vendedor?.substring(
              0,
              2,
            )} ${dados.Telefone_Parceiro_Vendedor?.substring(
              2,
              dados.Telefone_Parceiro_Vendedor?.length - 4,
            )}-${dados.Telefone_Parceiro_Vendedor?.substring(
              dados.Telefone_Parceiro_Vendedor?.length - 4,
              dados.Telefone_Parceiro_Vendedor?.length,
            )}`,
        };
      });

      terceiros = element?.terceiros?.map((dados, index) => {
        return {
          conta: `Contrato - ${index + 1} - Terceiros`,
          CPF_Terceiro: dados.CPF_Terceiro && dados.CPF_Terceiro,
          RG_Terceiro: dados.RG_Terceiro && dados.RG_Terceiro,
          Nome_Terceiro:
            dados.Nome_Terceiro && dados.Sobrenome_Terceiro
              ? `${dados.Nome_Terceiro} ${dados.Sobrenome_Terceiro}`
              : dados.Nome_Terceiro && dados.Nome_Terceiro,
          Email_Terceiro: dados.Email_Terceiro && dados.Email_Terceiro,
          Email_Gestor_Terceiro:
            dados.Email_Gestor_Terceiro && dados.Email_Gestor_Terceiro,
          Numero_Fax_Terceiro:
            dados.Numero_Fax_Terceiro && dados.Numero_Fax_Terceiro,
          Numero_Telefone_Reidencia_Terceiro:
            dados.Numero_Telefone_Reidencia_Terceiro &&
            dados.Numero_Telefone_Reidencia_Terceiro,
          Numero_Celular_Terceiro:
            dados.Numero_Celular_Terceiro && dados.Numero_Celular_Terceiro,
          Numero_Telefone_Terceiro:
            dados.Numero_Telefone_Terceiro && dados.Numero_Telefone_Terceiro,
          Caixa_Postal_Terceiro:
            dados.Caixa_Postal_Terceiro && dados.Caixa_Postal_Terceiro,
          Endereco_Terceiro: dados.Endereco_Terceiro && dados.Endereco_Terceiro,
          UF_Terceiro: dados.UF_Terceiro && dados.UF_Terceiro,
          Login_EPS_Terceiro:
            dados.Login_EPS_Terceiro && dados.Login_EPS_Terceiro,
          EPS_Callcenter_Terceiro:
            dados.EPS_Callcenter_Terceiro && dados.EPS_Callcenter_Terceiro,
          EPS_Celula_Callcenter_Terceiro:
            dados.EPS_Celula_Callcenter_Terceiro &&
            dados.EPS_Celula_Callcenter_Terceiro,
          Login_Avaya_Terceiro:
            dados.Login_Avaya_Terceiro && dados.Login_Avaya_Terceiro,
          Matricula_EPS_Terceiro:
            dados.Matricula_EPS_Terceiro && dados.Matricula_EPS_Terceiro,
          Numero_logradouro_Terceiro:
            dados.Numero_logradouro_Terceiro &&
            dados.Numero_logradouro_Terceiro,
          Complemento_Endereco_Terceiro:
            dados.Complemento_Endereco_Terceiro &&
            dados.Complemento_Endereco_Terceiro,
          Cidade_logradouro_Terceiro:
            dados.Cidade_logradouro_Terceiro &&
            dados.Cidade_logradouro_Terceiro,
          Distrito_Logradouro_Terceiro:
            dados.Distrito_Logradouro_Terceiro &&
            dados.Distrito_Logradouro_Terceiro,
          Data_Nascimento_Terceiro:
            dados.Data_Nascimento_Terceiro && dados.Data_Nascimento_Terceiro,
        };
      });
    }

    let data = {
      tipo,
      data_status,
      assinante,
      dados_cadastrais_funcionario,
      instaladores,
      pontos_de_venda,
      terceiros,
      propostas,
      proposta,
      dados_cadastrais_candidato,
      consentimento: response.data?.consentimento,
      anonym_request: response.data?.anonym_request,
    };

    yield put(personalSuccess(data));
  } catch (error) {
    const message = error.response.data.message;

    if (message?.includes('Titular inexistente')) {
      const toastrConfirmOptions = {
        onOk: () => {},
        onCancel: () => {},
        okText: 'Ok',
        disableCancel: true,
      };

      toastr.confirm(
        'CPF inválido ou inexistente na base para a categoria selecionada.',
        toastrConfirmOptions,
      );
    }
    yield put(personalFailure());
  }
}

function* categoria({ payload }: ReturnType<typeof categoriaRequest>) {
  const { company } = payload;

  try {
    const response = yield call(api.get, `/v1/categories`, {
      headers: {
        Authorization: '',
        'Content-Type': 'application/json',
        company: company,
      },
    });

    yield put(categoriaSuccess(response.data));
  } catch (error) {
    yield put(categoriaFailure(response.data));
  }
}

export default all([
  takeLatest(PersonalTypes.PERSONAL_RESQUEST, personal),
  takeLatest(PersonalTypes.CATEGORIA_RESQUEST, categoria),
]);
